import typography from './Typography.scss';
export * from './Utils';

export default typography;
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Typography/index.js